import { createReducer, on } from "@ngrx/store";
import * as WondeSyncActions from './wonde-sync.actions';
import { initialWondeSyncState } from "./wonde-sync.state";

export const wondeSyncReducer = createReducer(
  initialWondeSyncState,

  // LOAD
  on(WondeSyncActions.loadMismatches, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(WondeSyncActions.loadMismatchesSuccess, (state, { mismatches }) => ({
    ...state,
    loading: false,
    mismatches,
  })),
  on(WondeSyncActions.loadMismatchesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // SKIPPED: loaded on its own, so the pending list never waits for it.
  on(WondeSyncActions.loadSkippedMismatchesSuccess, (state, { mismatches }) => ({
    ...state,
    skippedMismatches: mismatches,
    skippedError: null,
  })),
  // Shown next to the skipped records only: the pending list loaded fine and keeps its page.
  on(WondeSyncActions.loadSkippedMismatchesFailure, (state, { error }) => ({
    ...state,
    skippedError: error,
  })),

  // LINK / CREATE / SKIP: the decided record leaves the list on success.
  on(WondeSyncActions.linkMismatch, WondeSyncActions.assignGroups, (state, { request }) => ({
    ...state,
    actionInProgressId: request.mismatchId,
    error: null,
  })),
  on(WondeSyncActions.createPupil, WondeSyncActions.dismissMismatch, (state, { mismatchId }) => ({
    ...state,
    actionInProgressId: mismatchId,
    error: null,
  })),
  on(
    WondeSyncActions.linkMismatchSuccess,
    WondeSyncActions.createPupilSuccess,
    WondeSyncActions.assignGroupsSuccess,
    (state, { mismatchId }) => ({
      ...state,
      actionInProgressId: null,
      mismatches: state.mismatches.filter((m) => m.id !== mismatchId),
      skippedMismatches: state.skippedMismatches.filter((m) => m.id !== mismatchId),
    })
  ),
  // A skipped pupil record moves to the skipped list, stamped with the skip time here: the skipped
  // list is not read again after a skip, since the read model may not show the record yet. The
  // admin's name arrives with the next read. A skipped year record is simply settled.
  on(WondeSyncActions.dismissMismatchSuccess, (state, { mismatchId }) => {
    const skipped = state.mismatches.find((m) => m.id === mismatchId && m.reason !== 'YEAR_GROUP_UNKNOWN');
    return {
      ...state,
      actionInProgressId: null,
      mismatches: state.mismatches.filter((m) => m.id !== mismatchId),
      skippedMismatches: skipped
        ? [{ ...skipped, status: 'DISMISSED' as const, resolvedDatetime: new Date().toISOString() },
          ...state.skippedMismatches.filter((m) => m.id !== mismatchId)]
        : state.skippedMismatches,
    };
  }),
  // Action failures are shown in a snackbar by the page, so they do not set the persistent error banner.
  on(
    WondeSyncActions.linkMismatchFailure,
    WondeSyncActions.createPupilFailure,
    WondeSyncActions.dismissMismatchFailure,
    WondeSyncActions.assignGroupsFailure,
    (state) => ({
      ...state,
      actionInProgressId: null,
    })
  )
);
